import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
import { FileInput } from 'browser/components/json-elements/atoms/file-input/file-input'
export const UIFileField = LabelFieldFactory({ InputComponent: FileInput })
